const { useEffect, useState } = React;
import { dbSubscribeCuePool } from "./data.jsx";

// groups the pool is organised in (an item may also carry any other text)
const POOL_GROUPS = ["Welcome scene", "VTR", "กิจกรรม", "IMMERSIVE", "Cool down"];
// drag payload type for a pool item being dropped onto a board column
const POOL_DRAG_TYPE = "application/x-rundown-pool";

function useCuePool() {
  const [items, setItems] = useState(null);
  useEffect(() => dbSubscribeCuePool((list) => setItems(list), () => setItems((v) => v || [])), []);
  return items;
}

function groupsOf(items) {
  const extra = [...new Set((items || []).map((i) => i.group).filter((g) => g && !POOL_GROUPS.includes(g)))];
  return [...POOL_GROUPS, ...extra];
}

export { POOL_GROUPS, POOL_DRAG_TYPE, useCuePool, groupsOf };
